import type { IProfileApiPort } from '@personnel/application/ports/IProfileApiPort';
import type { Profile } from '@personnel/domain/entities/Profile';

/**
 * Get Profiles Use Case
 *
 * Orquesta la obtención de perfiles a través del puerto de aplicación.
 * Punto central para agregar reglas de negocio futuras (cache, filtrado, auditoría).
 *
 * @module domains/personnel/application/use-cases/GetProfilesUseCase
 * @param props Dependencias del caso de uso
 * @param props.apiPort Implementación del puerto `IProfileApiPort`
 * @returns Objeto con método `execute` que retorna perfiles
 *
 * @example
 * import { getProfilesUseCase } from 'domains/personnel/application/use-cases/GetProfilesUseCase';
 * const useCase = getProfilesUseCase({ apiPort });
 * const profiles = await useCase.execute();
 */
export const getProfilesUseCase = (props: { apiPort: IProfileApiPort }) => {
  const { apiPort } = props;

  /**
   * Ejecuta la obtención de perfiles
   *
   * @returns {Promise<Profile[]>} Lista de perfiles en formato de dominio
   */
  const execute = async (): Promise<Profile[]> => {
    const profiles = await apiPort.getProfiles();
    return profiles;
  };

  return {
    execute,
  };
};
